// filepath: /c:/Users/magnu/Desktop/investorverden/Investorverden/src/pages/ivpartner.jsx
import React from "react";
import styles from "../css/style";
import { Navbar, Footer } from "../components/LandingPage";

const IVPartner = () => {
  return (
    <>
      <div className={`${styles.paddingX} ${styles.flexCenter} w-full overflow-hidden`}>
        <div className={`${styles.boxWidth}`}>
          {/* Pass onlyAuth prop to display only Log ind and Opret bruger */}
          <Navbar onlyAuth />
        </div>
      </div>
      <div className="bg-primary w-full overflow-hidden pt-[150px]">
        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
          <div className={`${styles.boxWidth}`}>
            <h1 className="text-3xl font-bold mb-6 text-white">
              Bliv IV Partner
            </h1>
            <p className="mb-4 text-dimWhite">
              Vil du være med til at forme fremtiden for investeringsanalyse i Danmark? Bliv en del af Investor Verden som affiliate partner.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-white">Hvad er en IV Partner?</h2>
            <p className="mb-4 text-dimWhite">
              Som IV Partner bliver du en del af vores voksende netværk af finansielle eksperter og content creators. Du får muligheden for at dele din viden og erfaring med vores community, samtidig med at du tjener på det.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-white">Fordele ved at blive Partner</h2>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>Provision på henvisninger af nye medlemmer</li>
              <li>Adgang til eksklusive analyseværktøjer</li>
              <li>Mulighed for at bygge dit personlige brand</li>
              <li>Del af et professionelt netværk</li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-white">Krav til Partnere</h2>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>Dokumenteret erfaring med investering eller finansiel analyse</li>
              <li>Aktiv tilstedeværelse på sociale medier eller andre platforme</li>
              <li>Passion for at dele viden og hjælpe andre</li>
              <li>Professionel tilgang og god kommunikationsevne</li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-white">Sådan Ansøger Du</h2>
            <p className="mb-4 text-dimWhite">
              Send en email til <a href="mailto:info@investorverden.dk" className="text-white underline">info@investorverden.dk</a> med følgende information:
            </p>
            <ul className="list-disc list-inside mb-4 text-dimWhite">
              <li>Dit fulde navn</li>
              <li>Din investeringserfaring</li>
              <li>Links til dine sociale medier profiler</li>
              <li>En kort beskrivelse af hvorfor du vil være IV Partner</li>
            </ul>

            <p className="mb-4 text-dimWhite">
              Vi gennemgår alle ansøgninger grundigt og vender tilbage inden for 5 arbejdsdage.
            </p>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default IVPartner;